var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6933 7.36229L17.0919 5.97165C15.9382 4.96966 15.4859 4.43065 14.8611 4.62119C14.082 4.85879 14.3385 6.358 14.3385 6.86414C13.1272 6.86414 11.8679 6.77098 10.6739 6.96508C6.73249 7.60589 5.5 10.4101 5.5 13.4314C6.61556 12.7475 7.73001 11.985 9.07078 11.6681C10.7444 11.2724 12.6136 11.4612 14.3385 11.4612C14.3385 11.9674 14.082 13.4666 14.8611 13.7042C15.569 13.9201 15.9382 13.3557 17.0919 12.3537L18.6933 10.9631C19.6755 10.1101 20.1667 9.68359 20.1667 9.16268C20.1667 8.64179 19.6755 8.2153 18.6933 7.36229Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68689 2.75C6.14832 2.75636 4.29536 2.84306 3.11119 4.02484C1.83325 5.30018 1.83325 7.35281 1.83325 11.4581C1.83325 15.5633 1.83325 17.6159 3.11118 18.8913C4.38911 20.1667 6.4459 20.1667 10.5595 20.1667C14.6731 20.1667 16.7299 20.1667 18.0078 18.8913C18.8976 18.0033 19.1678 16.7386 19.2499 14.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.e0489ca521e3239bf70b021540f8042f.svg";
export { ForwardRef as ReactComponent };